module.exports = __webpack_public_path__ + "static/media/BGnewReport.264d8c82.png";